import { makeAutoObservable } from 'mobx';
import { ICredentialsStore } from '../../integration-store';
import { IYodelCredentialsModel } from '../../../../../../models/IntegrationsTypes';

class YodelCredentialsStore implements ICredentialsStore {
    private _changes: IYodelCredentialsModel = {} as IYodelCredentialsModel;

    constructor() {
        makeAutoObservable(this, {}, { autoBind: true });
    }
    public get apiKey() { return this._changes.api_key; };
    public get clientId() { return this._changes.client_id; };
    public get clientSecret() { return this._changes.client_secret; };
    public get accountNumber() { return this._changes.account_number; };

    setApiKey(value: string) {
        this._changes.api_key = value;
    };

    setClientId(value: string) {
        this._changes.client_id = value;
    };

    setClientSecret(value: string) {
        this._changes.client_secret = value;
    };

    setAccountNumber(value: string) {
        this._changes.account_number = value;
    };

    /** ICredentialsStore implementation ************/
    public async getCredentials() {
        return { ...this._changes };
    }
}

export default YodelCredentialsStore;
